import { AppProviders } from "@/components/common/QueryProvider.tsx";
import { Toaster } from "@/components/ui/Sonner.tsx";
import { createRoot } from "react-dom/client";
import { RouterProvider } from "react-router";
import "./index.css";
import router from "./routes/index.tsx";

createRoot(document.getElementById("root")!).render(
  // <StrictMode>
  <AppProviders>
    <RouterProvider router={router} />
    <Toaster richColors visibleToasts={1} />
  </AppProviders>,
  // </StrictMode>,
);
